import React, { useContext } from "react";

import { Box, Button, TextField, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { withStyles } from "tss-react/mui";

import ClientInformationTable from "./ClientInformationTable";
import SelectTemplateButton from "./SelectTemplateButton";
import SystemRecommendedCalories from "./SystemRecommendedCalories";
import MealPlanFormStore from "../store/MealPlanFormStore";

interface Props {
  onSubmit(): void;
}

const LargeText = withStyles(Typography, {
  root: {
    fontWeight: 500,
    fontSize: "1.2rem",
    marginBottom: "8px",
  },
});

const CenteredTextField = withStyles(TextField, {
  root: {
    "& .MuiInputBase-input": {
      textAlign: "center",
      fontSize: "1.2rem",
    },
  },
});

export const AssessmentForm: React.FC<Props> = observer(({ onSubmit }) => {
  const store = useContext(MealPlanFormStore.Context);
  const { formState } = store;

  return (
    <>
      <Box marginBottom={8}>
        <ClientInformationTable />
      </Box>
      <Box marginBottom={3}>
        <SystemRecommendedCalories />
      </Box>
      <Box
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        justifyContent="center"
        alignItems="center"
        gap={{ xs: 3, md: 0 }}
        padding={{ xs: 3, md: 0 }}
        paddingTop={4} // adjustment for textfield helper text
        marginBottom={8}
        minHeight={{ md: "150px" }}
        bgcolor="#EDF0F5"
      >
        <Box width={{ xs: "100%", md: "300px" }} maxWidth="300px">
          <LargeText>Set recommended calories</LargeText>
          <CenteredTextField
            {...formState.field("recommendedCalories")}
            {...formState.fieldError("recommendedCalories")}
            type="number"
            placeholder="Enter calories"
            fullWidth
          />
        </Box>
        <Box width={{ xs: "100%", md: "300px" }} maxWidth="300px">
          <LargeText>(Optional) use a template:</LargeText>
          <SelectTemplateButton onSelect={(id) => store.applyTemplate(id)} />
        </Box>
      </Box>
      <Box display="flex" justifyContent="center">
        <Button
          disabled={formState.isInvalid}
          onClick={formState.handleSubmit(onSubmit)}
        >
          Next
        </Button>
      </Box>
    </>
  );
});

export default AssessmentForm;
